import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import authAxios from '../../src/modules/Shared/auth-header';
import { connect } from 'react-redux';
import actions from '../store/facility/action';

const withUrlMasking = (WrappedComponent) => {
    class MaskedComponent extends Component {

        state = {
            redirecting: false  // Prevents the loop
        };

        // Fetch facility code by Id
        getFacilityCode = async (id) => {
            let url = `/api/Facilities/GetFacilityCodeById/${id}`;
            try {
                const response = await authAxios.get(url);
                this.props.setFacilityId(id);
                return response.data.data; // Return facility code directly
            } catch (error) {
                console.error("Error fetching facility code:", error);
                return undefined; // Return undefined in case of an error
            }
        };

        // Fetch facility Id by Code
        getFacilityId = async (code) => {
            let url = `/api/Facilities/GetFacilityIdByCode/${code}`;
            try {
                const response = await authAxios.get(url);
                this.props.setFacilityId(response.data.data);
                return response.data.data; // Return facility id directly
            } catch (error) {
                console.error("Error fetching facility id:", error);
                return undefined; // Return undefined in case of an error
            }
        };

        // Reusable method for facility redirect logic
        async handleFacilityRedirect() {
            const { location, history } = this.props;
            const { redirecting } = this.state;
            const pathParts = location.pathname.split('/');

            // Prevent the loop with state flag
            if (redirecting) return;

            this.setState({ redirecting: true });  // Mark redirection in progress

            try {
                // If accessing the long URL `/directory/facility/view/:id`
                if (pathParts[1] === 'directory' && pathParts[2] === 'facility' && pathParts[3] === 'view') {
                    const id = Number(pathParts[4]);
                    if (!isNaN(id)) {
                        const code = await this.getFacilityCode(id);
                        if (code && !location.pathname.startsWith(`/facility/${code}`)) {
                            history.replace(`/facility/${code}`, { isDashboardActive: true });
                        } else {
                            //toast.error('Facility code not found');
                            history.push('/directory/facility');
                        }
                    }
                }

                // If accessing the short URL `/facility/:code`
                else if (pathParts[1] === 'facility') {
                    const code = pathParts[2];
                    const id = await this.getFacilityId(code);
                    if (id && !location.pathname.startsWith(`/directory/facility/view/${id}`)) {
                        history.replace(`/directory/facility/view/${id}`, { isDashboardActive: true });
                    } else {
                        //toast.error('Invalid facility code');
                        history.push('/directory/facility');
                    }
                }
            }
            finally {
                this.setState({ redirecting: false });  // Reset after redirection
            }
        }

        // Trigger redirection on component mount
        async componentDidMount() {
            await this.handleFacilityRedirect();
        }

        // Trigger redirection only if the URL changes
        async componentDidUpdate(prevProps) {
            // if (this.props.location.pathname !== prevProps.location.pathname) {
            //     await this.handleFacilityRedirect();
            // }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    const mapDispatchToProps = {
        setFacilityId: actions.setFacilityId,
        //setIsFacilityDashboardActive: actions.setIsFacilityDashboardActive
    };

    return withRouter(connect(null, mapDispatchToProps)(MaskedComponent));
};

export default withUrlMasking;
